import React from 'react';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import digital_transformation from 'src/assets/digital_transformation.png';
import projects_background from 'src/assets/projects_background.png';

const ProjectsComponent: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.projectsContainer}>
      <div className={classes.mainText}>
        <div className={classes.textWithImage}>
          <div>
            <h2 className={classes.projectsSubtitle}>{t('PROJECTS_TITLE')}</h2>
            <p className={classes.projectsDescription}>{t('PROJECTS_DESCRIPTION')}</p>
          </div>
          <img className={classes.projectsImage} src={projects_background} alt="Projects Background" />
        </div>
      </div>

      <div className={classes.secondText}>
        <h2 className={classes.digitlaTransformationTitle}>{t('DIGITAL_TRANSFORMATION_TITLE')}</h2>
        <p className={classes.digitlaTransformationDescription}>{t('DIGITAL_TRANSFORMATION_DESCRIPTION')}</p>
        <p className={classes.digitlaTransformationDescription}>{t('DIGITAL_TRANSFORMATION_DESCRIPTION_2')}</p>
      </div>

      <div className={classes.imgCentered}>
        <img src={digital_transformation} alt="Digital Transformation" />
      </div>
    </div>
  );
};

export default ProjectsComponent;
